module.exports = (parcelRequire.load("fI57s")).then(() => parcelRequire('S1ply'));